import { IStatusValue } from '../../shared/components/gmc-status-input/gmc-status-input.component';
import { ISocialNetworks } from './profile';
import { ILanguage, Language } from './language';

export interface IEmployerPersonalData {
  first_name?: string;
  last_name?: string;
  country?: string;
  city?: string;
  personal_email?: IStatusValue[];
  personal_phone?: IStatusValue[];
  languages?: ILanguage[];
  social_networks?: ISocialNetworks;
}

export class EmployerPersonalData {
  first_name: string;
  last_name: string;
  country: string;
  city: string;
  personal_email: IStatusValue[];
  personal_phone: IStatusValue[];
  languages: Language[];
  social_networks: ISocialNetworks;

  constructor( data: IEmployerPersonalData = {} ) {
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.country = data.country;
    this.city = data.city;
    this.personal_email = data.personal_email;
    this.personal_phone = data.personal_phone;
    this.languages = data.languages.length ? (data.languages || []).map(( item ) => new Language(item)) : [new Language()];
    this.social_networks = data.social_networks;
  }

  get fullname() {
    return `${this.first_name} ${this.last_name}`;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/employer-personal-data.ts